import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b062637a")

_pushScopeId("data-v-b062637a")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("年 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("月 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("日 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("年齢 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_select_box = _resolveComponent("select-box")
  const _component_vue_label = _resolveComponent("vue-label")
  const _component_small_edit_box = _resolveComponent("small-edit-box")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_vue_label, {
      class: "vue-content-edit-box",
      required: _ctx.required
    }, {
      label: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.title), 1)
      ]),
      content: _withId(() => [
        _createVNode(_component_select_box, {
          id: `${_ctx.keyValue}-barth-day-years`,
          class: "date-select-box",
          title: "year",
          items: _ctx.years,
          modelValue: _ctx.year,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.year = $event))
        }, {
          default: _withId(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["id", "items", "modelValue"]),
        _createVNode(_component_select_box, {
          id: `${_ctx.keyValue}-barth-day-month`,
          class: "date-select-box",
          title: "month",
          items: _ctx.months,
          modelValue: _ctx.month,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.month = $event))
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["id", "items", "modelValue"]),
        _createVNode(_component_select_box, {
          id: `${_ctx.keyValue}-barth-day-days`,
          class: "date-select-box",
          title: "days",
          items: _ctx.days,
          modelValue: _ctx.day,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.day = $event))
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["id", "items", "modelValue"])
      ]),
      _: 1
    }, 8, ["required"]),
    _createVNode(_component_small_edit_box, {
      class: "vue-content-edit-box",
      value: _ctx.age,
      readonly: ""
    }, {
      default: _withId(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["value"])
  ], 64))
})